import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y } from 'swiper/modules';
import MicroModal from 'micromodal';
import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  if (!$('[data-au-gallery]')) return;

  const slidersArray = [];

  setSliderModalContent();
  buildMainSlider();
  clickDetail(slidersArray);
}

/**
 * get html inside gallery before slider init, so we can clone it without any inline styles, arias...
 */
function setSliderModalContent() {
  const galleryWrapperHtmls = [];

  $$('[data-au-gallery-slider]').forEach((el, index) => {
    const gallery = el.closest('[data-au-gallery]'),
      galleryId = gallery.dataset.auGallery,
      galleryContent = $(`#${galleryId}-content`),
      gallerySection = el.closest('[data-au-gallery-section]'),
      gallerySectionTitle = gallerySection.querySelector('[data-au-heading-title]');

    if (gallerySectionTitle) {
      const gallerySectionTitleClone = gallerySectionTitle.cloneNode(true);
      gallerySectionTitleClone.classList.add('au-hide');
      galleryContent.prepend(gallerySectionTitleClone);
    }

    galleryWrapperHtmls.push(el.innerHTML);
    galleryContent.innerHTML = galleryWrapperHtmls[index];
    galleryContent.classList.add('swiper');
    galleryContent.classList.add('au-gallery__modal-content');
    galleryContent.setAttribute('data-au-gallery-modal-slider', '');
    galleryContent.querySelectorAll('[data-au-card-video]').forEach((video) => {
      video.remove();
    });
    galleryContent.querySelectorAll('[data-au-gallery-actions]').forEach((actions) => {
      actions.remove();
    });
    galleryContent.querySelectorAll('[data-au-gallery-slide-title]').forEach((title) => {
      title.remove();
    });
    galleryContent.querySelectorAll('[data-au-gallery-picture]').forEach((el) => {
      const pictureSource = el.querySelector('source');
      const pictureImg = el.querySelector('img');
      pictureSource.setAttribute('srcset', pictureSource.dataset.auGalleryModalSrcset);
      pictureImg.setAttribute('src', pictureImg.dataset.auGalleryModalSrc);
    });
  });
}

/**
 * @param el
 * play video inside modal gallery
 */
function playModalGalleryVideo(el) {
  const slideActive = el.querySelectorAll('[data-au-gallery-slide]')[el.swiper.activeIndex];
  const iframe = slideActive.querySelector('[data-au-gallery-iframe]');
  if (!iframe) return;

  const src = iframe.dataset.auGalleryIframe;

  if (iframe) {
    iframe.setAttribute('src', `${src}?rel=0&autoplay=1`);
    iframe.classList.add('au-gallery-slide__video--visible');
  }
}

/**
 * stop all modal gallery videos
 */
function stopAllModalGalleryVideos() {
  $$('[data-au-gallery-iframe]').forEach((iframeVideo) => {
    iframeVideo.setAttribute('src', '');
  });
}

/**
 * build main slider
 */
function buildMainSlider() {
  $$('[data-au-gallery-slider]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y],
      slideToClickedSlide: true,
      ...sliderConfig,
      slidesPerView: 1.125,
      breakpoints: {
        768: {
          slidesPerView: 2.325,
        },
      },
    });
  });
}

/**
 * @param slidersArray sliders array. we push to this array every slider that we create. when close modal, destroy all
 * @param galleryIndex index of gallery. just build the modal slider inside clicked gallery
 * @param initialSlide initial slide, corresponding to clicked index card
 * build modal slider
 */
function buildModalSlider(slidersArray, initialSlide) {
  const slider = $$('[data-au-gallery-modal-slider]')[0];
  const newsSlider = new Swiper(slider, {
    modules: [Navigation, Scrollbar, A11y],
    initialSlide,
    on: {
      init() {
        playModalGalleryVideo(slider);
      },
      slideChange() {
        stopAllModalGalleryVideos();
        playModalGalleryVideo(slider);
      },
    },
    ...sliderConfig,
  });

  slidersArray.push(newsSlider);
}

/**
 * @param slidersArray
 * function triggered at click on gallery slide
 */
function clickDetail(slidersArray) {
  $$('[data-au-gallery-slide]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (e.target.dataset.auGalleryBtnDetail !== '') return false;
      toggleGalleryModal(e, slidersArray);
    });
  });
}

/**
 * @param e
 * @param slidersArray
 * function that triggers build modal slider when open modal and stop all videos and destroy all sliders when close it
 * destroy is necesary to avoid some errors when open and close modal
 */
function toggleGalleryModal(e, slidersArray) {
  const button = e.target,
    slide = button.closest('[data-au-gallery-slide]'),
    slideTitle = slide.querySelector('[data-au-gallery-slide-title]')
      ? slide.querySelector('[data-au-gallery-slide-title]').innerText
      : '',
    slideIndex = Array.from(slide.parentNode.children).indexOf(slide),
    gallerySection = button.closest('[data-au-gallery-section]'),
    gallerySectionTitle = gallerySection.querySelector('[data-au-heading-title]')
      ? gallerySection.querySelector('[data-au-heading-title]').innerText
      : '',
    gallery = button.closest('[data-au-gallery]'),
    galleryId = gallery.dataset.auGallery;

  MicroModal.show(galleryId, {
    onShow: () => {
      buildModalSlider(slidersArray, slideIndex);

      if (button.dataset.auGalleryModalVideo) {
        datalayerPushGeneric(e, 'navigation', 'clickVideo', slideTitle);
      } else {
        datalayerPushGeneric(e, 'navigation', 'clickImagen', gallerySectionTitle, slideTitle || `imagen${slideIndex}`);
      }
    },
    onClose: () => {
      stopAllModalGalleryVideos();
      slidersArray.forEach((slider) => slider.destroy());
      button.blur(); // blur focus of button so, when we close modal, we can swipe correctly

      datalayerPushGeneric(e, 'navigation', 'clickBoton', slideTitle, 'cerrar');
    },
  });
}

export default { init };
